/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { memberInputSchema } from './memberInputSchema';

export const resolveMembersRequestSchema = z.object({
  get members() {
    return z.array(memberInputSchema).min(0).max(1000);
  },
});
